import {useEffect} from 'react'
import {Navigate, Routes, useNavigate} from 'react-router-dom'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    logout()
    localStorage.removeItem("productName")
    localStorage.removeItem("organization")
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth' />
    </Routes>
  )
}
